export default __webpack_public_path__ + "static/media/picture-introduction.eeeb6820.jpg";